import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from '../features/user/userSlice';
import filesReducer from '../features/files/filesSlice';
import editorReducer from '../features/editor/editorSlice';
import projectsReducer from '../features/projects/projectsSlice';
import notesReducer from '../features/notes/notesSlice';
import corkboardsReducer from '../features/corkboards/corkboardsSlice';
import timelinesReducer from '../features/timelines/timelinesSlice';
import charactersReducer from '../features/characters/charactersSlice';

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'editor', 'corkboards', 'timelines', 'characters'], // Persist user, editor, corkboards, timelines, and characters state
  debug: true, // Enable debug logging
};

const rootReducer = combineReducers({
  user: userReducer,
  files: filesReducer,
  editor: editorReducer,
  projects: projectsReducer,
  notes: notesReducer,
  corkboards: corkboardsReducer,
  timelines: timelinesReducer,
  characters: charactersReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
